import isNil from 'lodash/isNil';

import { FeatureToggleEnum } from '../enums';

const stringToBooleanConverter: FTParser<string> = (value: string): boolean => {
    let result = false;

    if (['1', 'true'].includes(value.trim())) {
        result = Boolean(value);
    }

    return result;
};

const stringToNumberConverter: FTParser<string> = (value: string): number | undefined => {
    let result = undefined;

    if (!isNil(value) && value.length > 0 && !isNaN(+value)) {
        result = Number(value);
    }

    return result;
};

const stringArrayParser: FTParser<string[]> = (value: string[]): string[] => {
    if (!Array.isArray(value)) {
        return [];
    }

    return value;
};

const simpleParser = <T>(value: T): T => value;

type FTParser<T> = (value: T) => unknown;

export const FeatureToggleValueParserMap: Record<FeatureToggleEnum, FTParser<any>> = {
    [FeatureToggleEnum.USE_AUTOCOMPLETE_ES_VERSION]: stringToNumberConverter,
    [FeatureToggleEnum.USE_HOME_PAGE_ES_VERSION]: stringToNumberConverter,
    [FeatureToggleEnum.USE_MAP_TILING]: stringToBooleanConverter,
    [FeatureToggleEnum.USE_MAP_TILING_V2]: stringToBooleanConverter,
    [FeatureToggleEnum.USE_RANKING_SIMULATOR]: stringToBooleanConverter,
    [FeatureToggleEnum.USE_LISTING_SSR]: stringArrayParser,
    [FeatureToggleEnum.SM_CONFIRMATION_EMAIL_ID]: simpleParser,
    [FeatureToggleEnum.SM_CONFIRMATION_EMAIL_ID_HOMEPAGE]: simpleParser,
};
